import { i18n } from '@/i18n';

// Backwards-compatible translator: all existing consumers do
//   const t = useTranslator();  ->  t('Some key')
// Translation is now driven entirely by vue-i18n (see src/i18n). Calling
// i18n.global.t keeps results reactive to locale changes and to the async
// arrival of applicationResources overlays.
export function useTranslator() {
	return (key, ...args) => {
		if (!key) return '';
		return i18n.global.t(key, ...args);
	};
}
